const LoginPage = {
  seo: {
    title: 'Login',
  },

  title: 'Welcome Back!',
  subtitle: 'Enter your email and password to login to your account.',
};

export default LoginPage;
